// Custom Messages
export const frCustomMessages = {
    teamEfficiency: "Efficacité de l'équipe",
    teamMembers: "Membres de l'équipe",
    dashboard: 'Tableau de bord',
    planning: 'Planification',
    info: 'Info',
    profile: 'Profil',
    language: 'Langue',
    trend: 'Tendance',
    volume: 'Le volume',
    myTeam: 'Mon équipe',
    allTeams: 'Toutes les équipes',
    teamCalendar: "Calendrier d'équipe",
    saveChanges: 'Sauvegarder les modifications',
    cancel: 'Annuler',
    warehouse: 'Entrepôt De Café',
    startFreeTrial: "Démarrer l'essai gratuit",
    buyNow: 'Acheter maintenant',
    getSource: 'Récupérer le code source sur GitHub',
    demoInfo:
        "Cette application de démonstration est construite à l'aide des composants Kendo UI for Angular.",
    firstName: 'Prénom',
    middleName: 'Deuxième nom',
    lastName: 'Nom de famille',
    email: 'Adresse e-mail',
    phoneNumber: 'Numéro de téléphone',
    country: 'Pays',
    biography: 'Biographie courte',
    public: 'Inclure dans le répertoire public',
    team: 'Équipe',
    employee: 'Employé',
    contactName: 'Nom du contact',
    jobTitle: 'Titre du poste',
    status: 'Statut',
    performance: 'Performance',
    rating: 'Évaluation',
    engagement: 'Engagement',
    budget: 'Budget',
    contacts: 'Contacts',
    address: 'Adresse',
    phone: 'Téléphone',
    gridSearch: 'Rechercher dans toutes les colonnes ...',
    exportExcel: 'Exporter vers Excel',
    exportPdf: 'Exporter au format PDF'
};

// Kendo Angular Component Messages
export const frComponentMessages = {
    // Grid
    'kendo.grid.groupPanelEmpty': 'Faites glisser un en-tête de colonne et déposer ici pour grouper par cette colonne.',
    'kendo.grid.noRecords': 'Aucun élément disponible.',
    'kendo.grid.pagerFirstPage': 'Aller à la première page',
    'kendo.grid.pagerPreviousPage': 'Aller à la page précédente',
    'kendo.grid.pagerNextPage': 'Aller à la page suivante',
    'kendo.grid.pagerLastPage': 'Aller à la dernière page',
    'kendo.grid.pagerPage': 'Page',
    'kendo.grid.pagerOf': 'de',
    'kendo.grid.pagerItems': 'éléments',
    'kendo.grid.pagerItemsPerPage': 'éléments par page',
    'kendo.grid.pagerPageNumberInputTitle': 'Page Number',
    'kendo.grid.filter': 'Filtrer',
    'kendo.grid.filterEqOperator': 'Est égal à',
    'kendo.grid.filterNotEqOperator': 'N’est pas égal à',
    'kendo.grid.filterIsNullOperator': 'Est nulle',
    'kendo.grid.filterIsNotNullOperator': 'N’est pas nulle',
    'kendo.grid.filterIsEmptyOperator': 'Est vide',
    'kendo.grid.filterIsNotEmptyOperator': 'N’est pas vide',
    'kendo.grid.filterStartsWithOperator': 'Commence par',
    'kendo.grid.filterContainsOperator': 'Contient',
    'kendo.grid.filterNotContainsOperator': 'Ne contient pas',
    'kendo.grid.filterEndsWithOperator': 'Se termine par',
    'kendo.grid.filterGteOperator': 'Est supérieur ou égal à',
    'kendo.grid.filterGtOperator': 'Est supérieur à',
    'kendo.grid.filterLteOperator': 'Est inférieur ou égal à',
    'kendo.grid.filterLtOperator': 'Est inférieur',
    'kendo.grid.filterIsTrue': 'est vrai',
    'kendo.grid.filterIsFalse': 'est fausse',
    'kendo.grid.filterBooleanAll': '(Tout)',
    'kendo.grid.filterAfterOrEqualOperator': 'Est postérieur ou égal à',
    'kendo.grid.filterAfterOperator': 'Est postérieur',
    'kendo.grid.filterBeforeOperator': 'Est antérieur',
    'kendo.grid.filterBeforeOrEqualOperator': 'Est antérieur ou égal à',
    'kendo.grid.filterFilterButton': 'Filtrer',
    'kendo.grid.filterClearButton': 'Effacer filtre',
    'kendo.grid.filterAndLogic': 'Et',
    'kendo.grid.filterOrLogic': 'Ou',
    'kendo.grid.filterDateToggle': 'Afficher le calendrier',
    'kendo.grid.filterDateToday': "Aujourd'hui",
    'kendo.grid.filterNumericDecrement': 'Diminuer la valeur',
    'kendo.grid.filterNumericIncrement': 'Augmenter la valeur',
    'kendo.grid.loading': 'Chargement',
    'kendo.grid.sort': 'Tri',
    'kendo.grid.columnMenu': 'Menu des colonnes',
    'kendo.grid.columns': 'Colonnes',
    'kendo.grid.lock': 'Bloquer',
    'kendo.grid.unlock': 'Débloquer',
    'kendo.grid.stick': 'Stick',
    'kendo.grid.unstick': 'Unstick',
    'kendo.grid.setColumnPosition': 'Set Column Position',
    'kendo.grid.sortAscending': 'Tri croissant',
    'kendo.grid.sortDescending': 'Tri décroissant',
    'kendo.grid.columnsApply': 'Appliquer',
    'kendo.grid.columnsReset': 'Réinitialiser',
    'kendo.grid.sortable': 'Sortable',
    'kendo.grid.sortedAscending': 'Sorted ascending',
    'kendo.grid.sortedDescending': 'Sorted descending',
    'kendo.grid.sortedDefault': 'Not sorted',

    // DropDowns
    'kendo.autocomplete.noDataText': 'Aucun enregistrement trouvé',
    'kendo.autocomplete.clearTitle': 'Effacer',
    'kendo.combobox.noDataText': 'Aucun enregistrement trouvé',
    'kendo.combobox.clearTitle': 'Effacer',
    'kendo.dropdownlist.noDataText': 'Aucun enregistrement trouvé',
    'kendo.dropdownlist.clearTitle': 'Effacer',

    // Calendar
    'kendo.calendar.today': `Aujourd'hui`,

    // TextBox
    'kendo.textbox.clearTitle': 'Effacer',

    // DatePicker
    'kendo.datepicker.today': `Aujourd'hui`,
    'kendo.datepicker.toggle': 'Afficher le calendrier',

    // DateInput
    'kendo.dateinput.increment': 'Augmenter la valeur',
    'kendo.dateinput.decrement': 'Diminuer la valeur',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Augmenter la valeur',
    'kendo.numerictextbox.decrement': 'Diminuer la valeur',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Onglet de date',
    'kendo.datetimepicker.timeTab': 'Heures',
    'kendo.datetimepicker.timeTabLabel': 'Onglet des heures',
    'kendo.datetimepicker.toggle': 'Afficher le calendrier',
    'kendo.datetimepicker.accept': 'Valider',
    'kendo.datetimepicker.acceptLabel': 'Valider',
    'kendo.datetimepicker.cancel': 'Annuler',
    'kendo.datetimepicker.cancelLabel': 'Annuler',
    'kendo.datetimepicker.now': 'Maintenant',
    'kendo.datetimepicker.nowLabel': 'Sélectionner maintenant',
    'kendo.datetimepicker.today': "Aujourd'hui",
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    "kendo.timepicker.accept": "Valider",
    "kendo.timepicker.acceptLabel": "Valider",
    "kendo.timepicker.cancel": "Annuler",
    "kendo.timepicker.cancelLabel": "Annuler",
    "kendo.timepicker.now": "Maintenant",
    "kendo.timepicker.nowLabel": "Maintenant",
    "kendo.timepicker.toggle": "Afficher le sélecteur",

    // FileSelect
    "kendo.fileselect.cancel": "Annuler",
    "kendo.fileselect.clearSelectedFiles": "Supprimer",
    "kendo.fileselect.dropFilesHere": "déposer les fichiers à télécharger ici",
    "kendo.fileselect.headerStatusUploaded": "Complété",
    "kendo.fileselect.headerStatusUploading": "Téléchargement...",
    "kendo.fileselect.invalidFileExtension": "Type de fichier non autorisé.",
    "kendo.fileselect.invalidMaxFileSize": "Le fichier est trop volumineux.",
    "kendo.fileselect.invalidMinFileSize": "Le fichier est trop petit.",
    "kendo.fileselect.remove": "Retirer",
    "kendo.fileselect.retry": "Réessayer",
    "kendo.fileselect.select": "Sélectionner...",
    "kendo.fileselect.uploadSelectedFiles": "Télécharger des fichiers",
    "kendo.fileselect.externalDropFilesHere": "Drag and drop files here to upload",
    "kendo.fileselect.filesBatchStatus": "files",
    "kendo.fileselect.filesBatchStatusFailed": "files failed to upload.",
    "kendo.fileselect.filesBatchStatusUploaded": "files successfully uploaded.",
    "kendo.fileselect.fileStatusFailed": "File failed to upload.",
    "kendo.fileselect.fileStatusUploaded": "File successfully uploaded.",
    "kendo.fileselect.headerStatusPaused": "Paused",

    // Scheduler
    "kendo.scheduler.agendaViewTitle": "Agenda",
    "kendo.scheduler.allDay": "toute la journée",
    "kendo.scheduler.allEvents": "Tous les évènements",
    "kendo.scheduler.calendarToday": "AUJOURD'HUI",
    "kendo.scheduler.cancel": "Annuler",
    "kendo.scheduler.save": "Sauvegarder",
    "kendo.scheduler.editorEventTitle": "Evènement",
    "kendo.scheduler.editorEventStart": "Début",
    "kendo.scheduler.editorEventStartTimeZone": "Début Zone Horaire",
    "kendo.scheduler.editorEventEnd": "Fin",
    "kendo.scheduler.editorEventEndTimeZone": "Fin Zone Horaire",
    "kendo.scheduler.dateHeader": "Date",
    "kendo.scheduler.dayViewTitle": "Jour",
    "kendo.scheduler.deleteConfirmation": "Etes-vous sûr de vouloir supprimer cet évènement ?",
    "kendo.scheduler.deleteDialogTitle": "Suppression de l'évènement'",
    "kendo.scheduler.deleteOccurrence": "Supprimer l'occurrence courante",
    "kendo.scheduler.deleteRecurringConfirmation": "Voulez-vous supprimer seulement cette occurrence ou toute la série ?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Voulez-vous supprimer seulement cet évènement ou toute la série ?",
    "kendo.scheduler.deleteSeries": "Supprimer la série",
    "kendo.scheduler.deleteTitle": "Suppression de l'évènement",
    "kendo.scheduler.destroy": "Supprimer",
    "kendo.scheduler.editOccurrence": "Modifier l'occurrence courante",
    "kendo.scheduler.editorEventAllDay": "Toute la journée",
    "kendo.scheduler.editorEventDescription": "Description",
    "kendo.scheduler.editorEventSeparateTimeZones": "Utiliser une Zone Horaire de début et de fin différente",
    "kendo.scheduler.editorEventTimeZone": "Zone Horaire",
    "kendo.scheduler.editorTitle": "Evènement",
    "kendo.scheduler.editRecurringConfirmation": "Voulez-vous modifier seulement cet évènement ou toute la série?",
    "kendo.scheduler.editRecurringDialogTitle": "Modification de l'élément courant",
    "kendo.scheduler.editSeries": "Modifier la série",
    "kendo.scheduler.eventHeader": "Evènement",
    "kendo.scheduler.monthViewTitle": "Mois",
    "kendo.scheduler.multiDayViewTitle": "Multi-Jours",
    "kendo.scheduler.nextTitle": "Prochain",
    "kendo.scheduler.previousTitle": "Précédent",
    "kendo.scheduler.recurrenceEditorDailyInterval": "jour(s)",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Répéter chaque :",
    "kendo.scheduler.recurrenceEditorEndAfter": "Après",
    "kendo.scheduler.recurrenceEditorEndLabel": "Fin",
    "kendo.scheduler.recurrenceEditorEndNever": "Jamais",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
    "kendo.scheduler.recurrenceEditorEndOn": "Le",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Une fois par jour",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Une fois par mois",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Jamais",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Une fois par semaine",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Une fois par an",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "Jour",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "mois",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Répéter chaque :",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Répéter le :",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "premier",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "quatrième",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "dernier",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "second",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "troisième",
    "kendo.scheduler.recurrenceEditorRepeat": "Répéter",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "jour",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "jour de la semaine",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "jour du week-end",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "semaine(s)",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Répéter chaque :",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Répéter le :",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "année(s)",
    "kendo.scheduler.recurrenceEditorYearlyOf": "de",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Répéter chaque :",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Répéter le :",
    "kendo.scheduler.showFullDay": "Montrer toute la journée",
    "kendo.scheduler.showWorkDay": "Montrer les heures ouvrables",
    "kendo.scheduler.timeHeader": "Heure",
    "kendo.scheduler.timelineMonthViewTitle": "Timeline Mois",
    "kendo.scheduler.timelineViewTitle": "Timeline",
    "kendo.scheduler.timelineWeekViewTitle": "Timeline Semaine",
    "kendo.scheduler.today": "Aujourd'hui",
    "kendo.scheduler.weekViewTitle": "Semaine",
    "kendo.scheduler.workWeekViewTitle": "Semaine de travail",

    // RecurrenceEditor
    "kendo.recurrenceeditor.dailyInterval": "jour(s)",
    "kendo.recurrenceeditor.dailyRepeatEvery": "Répéter chaque :",
    "kendo.recurrenceeditor.endAfter": "Après",
    "kendo.recurrenceeditor.endLabel": "Finir :",
    "kendo.recurrenceeditor.endNever": "Jamais",
    "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
    "kendo.recurrenceeditor.endOn": "Le",
    "kendo.recurrenceeditor.frequenciesDaily": "Une fois par jour",
    "kendo.recurrenceeditor.frequenciesMonthly": "Une fois par mois",
    "kendo.recurrenceeditor.frequenciesNever": "Jamais",
    "kendo.recurrenceeditor.frequenciesWeekly": "Une fois par semaine",
    "kendo.recurrenceeditor.frequenciesYearly": "Une fois par an",
    "kendo.recurrenceeditor.monthlyDay": "Jour",
    "kendo.recurrenceeditor.monthlyInterval": "mois",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Répéter chaque :",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Répéter le :",
    "kendo.recurrenceeditor.offsetPositionsFourth": "quatrième",
    "kendo.recurrenceeditor.offsetPositionsLast": "dernier",
    "kendo.recurrenceeditor.offsetPositionsSecond": "second",
    "kendo.recurrenceeditor.offsetPositionsThird": "troisième",
    "kendo.recurrenceeditor.repeat": "Répéter",
    "kendo.recurrenceeditor.weekdaysDay": "jour",
    "kendo.recurrenceeditor.weekdaysWeekday": "jour de la semaine",
    "kendo.recurrenceeditor.weekdaysWeekendday": "jour de week-end",
    "kendo.recurrenceeditor.weeklyInterval": "semaine(s)",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Répéter chaque :",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Répéter le :",
    "kendo.recurrenceeditor.yearlyInterval": "année(s)",
    "kendo.recurrenceeditor.yearlyOf": "de",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Répéter chaque :",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Répéter le :",
};
